import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const CAMPUS_CONSTANTS = {
  PAGE_CAMPUS_TITLE: "Sedes",
  PAGE_CREATE_TITLE: "Agregar sede",
  PAGE_EDIT_TITLE: "Editar sede",
  BUTTON: {
    ADD_CAMPUS_TEXT: "Crear sede"
  },
  LABELS: {
    NAME: "Nombre de sede*",
    ADDRESS: "Dirección de sede*"
  },
  CAMPUS_REASON_MODAL: {
    TITLE: "Eliminar sede",
    MESSAGE: "Ingrese la razón por la cual va a deshabilitar la sede: "
  },
  DIALOG_MESSAGE: {
    CAMPUS_USED: "La sede no se puede eliminar porque está en uso",
    CAMPUS_DELETED: "Sede eliminada correctamente"
  }
};

export const CAMPUS_FILTERS: Filter[] = [
  {
    mainFilterKey: "campus",
    mainFilterName: "Sedes",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para las Sedes",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Sede",
        key: "name",
        display: "unique",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter"
      },
      {
        default: false,
        name: "Estado",
        placeholder: "Estado de Sede",
        key: "state",
        type: "secondaryFilter",
        display: "list",
        options: [
          { key: "Activo", name: "Activo" },
          { key: "Inactivo", name: "Inactivo" }
        ],
        operators: OPERATORS_FILTERS
      }
    ]
  }
];

export const CAMPUS_ACCESS = {
  GET: "consultar sedes",
  POST: "crear sedes",
  PUT: "modificar sedes",
  DELETE: "eliminar sedes"
};
